<div class="flex flex-col gap-4">
  <div class="flex items-center justify-between">
    <h1 class="primaryColor text-2xl font-bold" i18n="@@editcity">Edit city</h1>
  </div>
</div>
<div class="mb-4 rounded-2xl p-[16px]">
  <app-update-city-component />
</div>
